import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { All_LIST_QUESTION, All_LIST_QUESTION_CLEAR } from './constants';
import {
  AllListQuestionDataActionTypes,
  AllListQuestionError,
  AllListQuestionState,
  AllListQuestionSuccess,
} from './types';

const initialState: AllListQuestionState = {
  status: idle,
  entities: [],
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AllListQuestionDataActionTypes,
  ): AllListQuestionState => {
    switch (action.type) {
      case All_LIST_QUESTION + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case All_LIST_QUESTION + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllListQuestionSuccess).payload.items;
        break;
      }
      case All_LIST_QUESTION + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllListQuestionError).error;
        break;
      }
      case All_LIST_QUESTION + IDLE: {
        draft.status = idle;
        break;
      }
      case All_LIST_QUESTION_CLEAR: {
        draft = initialState;
        return draft;
      }
      default:
        return draft;
    }
  },
);
